import ReactDOM from "react-dom";
import "@webrotate360/imagerotator/build/css/all.css";

import WebRotate from "./components/WebRotate";
import IntlProviderWrapper from "./IntlContext";
import reportWebVitals from "./reportWebVitals";

import "./resources/_antd.less"; // redefinition AntDesign variables
import "./styles/common.scss";
import "./styles/global.scss";
import "./styles/icon-config.scss";
import "./styles/icon.css";

declare global {
  interface Window {
    onWebRotateLoaded: (ids: string[]) => void;
    onDestroyWebRotate: () => void;
    updateDimensions: () => void;
    renderWebRotate: ({ code, language, webRotateId }) => void;
    onClickHotspots: (callback: (key: string) => void) => void;
    gotoHotspots: (hotspotsName: string, timeoutView?: number) => void;
    hideHotspots: (hotspotsNames: string[]) => void;
    onWebRotateDrag: () => void;
  }
}

window.renderWebRotate = ({ code, language, webRotateId }) => {
  let rootEle: ReactDOM.Container;

  if (webRotateId) {
    rootEle = document.getElementById(webRotateId);
  } else {
    // using only for React App -> get first div element in body
    const parentNode = document
      .getElementsByTagName("body")[0]
      .getElementsByTagName("div")[0];
    // create new render element
    rootEle = document.createElement("div");
    rootEle.id = "web-rotate";

    parentNode.appendChild(rootEle);
  }

  ReactDOM.render(
    <IntlProviderWrapper>
      <WebRotate code={code} language={language} />
    </IntlProviderWrapper>,
    rootEle
  );
};

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
